export const PARTICIPANT_LAYOUT_FLAT_VOICE_AUDIO_PROPERTY = "participantLayoutFlatVoiceAudioEnabled";

export function shouldUseParticipantLayoutFlatVoiceAudio(app, sourceType, avatarAudioSourceType) {
  return Boolean(app?.[PARTICIPANT_LAYOUT_FLAT_VOICE_AUDIO_PROPERTY]) && sourceType === avatarAudioSourceType;
}

export function getParticipantLayoutFlatVoiceAudioSettings() {
  return {
    audioType: "stereo"
  };
}
